<template>
  <section class="modal-update-template">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">レポートファイルの更新</p>
      </header>

      <section class="modal-card-body main">
        <b-field>
          <b-upload v-model="dropFile"
            drag-drop
            :accept="allowedMimeType.join(',')">
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>ファイルを更新する場合は、</p>
                <p>アップロードするファイルをドロップしてください。</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <b-table :data="dropFiles">
          <template slot-scope="props">
            <b-table-column field="id" label="ID">
              {{ customFile.id | short }}
            </b-table-column>

            <b-table-column field="group" label="グループ">
              <b-field
                :type="{'is-danger': errors.has('group')}"
                :message="errors.first('group')">
                <b-autocomplete
                  v-model="customFile.group"
                  placeholder="グループ名"
                  open-on-focus
                  :data="getFilteredTags">
                </b-autocomplete>
              </b-field>
            </b-table-column>
            <b-table-column field="name" label="表示名">
              <b-field
                :type="{'is-danger': errors.has('name')}"
                :message="errors.first('name')">
                <b-input
                  name="name"
                  data-vv-as="表示名"
                  v-model="customFile.name"
                  placeholder="表示名"
                  v-validate="'required'">
                </b-input>
              </b-field>
            </b-table-column>
            <b-table-column field="name" label="ファイル名">{{ props.row.name || customFile.org_file | inValid }} </b-table-column>
            <b-table-column field="size" label="サイズ">{{ props.row.size || customFile.size | inValid}}</b-table-column>
            <!-- b-table-column field="type" label="タイプ">{{ props.row.type || customFile.kind | inValid}}</b-table-column -->
          </template>
        </b-table>
        <b-message type="is-warning">
          ファイルを更新した場合、もとのファイルは削除されますのでご注意ください。
        </b-message>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">キャンセル</button>
        <button class="button is-primary" @click="handleOnUpload">更新</button>
      </footer>
    </div>
  </section>
</template>

<script>
import DeleteButton from "@/components/molecules/Buttons/DeleteButton";
import snackbar from "@/shared/snackbar";

export default {
  components: { DeleteButton },
  data() {
    return {
      // upload の受け口
      dropFile: [],
      // テーブルに表示するための配列化された file. 初期状態ではダミー
      dropFiles: [ new File([], this.$props.currentInfo.org_file )],
      // メタデータ(グループ/表示名)
      customFile: this.$props.currentInfo,
      // グループ
      groups: this.$store.state.report.reportLabels,
      fileIsUpdated: false,
      allowedMimeType: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-word.document.macroEnabled.12",
        "application/vnd.ms-word.template.macroEnabled.12",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
        "application/vnd.ms-excel.template.macroEnabled.12",
        "application/vnd.ms-excel.addin.macroEnabled.12",
        "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
      ],
    };
  },
  props: {
    reportId: {
      type: String,
      default: "",
    },
    currentInfo: {
      type: Object,
    },
  },
  watch: {
    dropFile() {
      console.log(this.dropFile);
      this.dropFiles = [this.dropFile];
      this.fileIsUpdated = true;
    },
  },
  computed: {
    getFilteredTags() {
      return this.groups.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.customFile.group.toLowerCase()) >= 0;
      });
    },
  },
  methods: {
    handleOnUpload() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        console.log(this.dropFiles);
        console.log(this.customFile);

        const submitInfo = {
          name: this.customFile.name,
          group: this.customFile.group || "-",
        };

        // file の更新があった場合
        if (this.fileIsUpdated) {
          submitInfo.file = this.dropFile;
        }

        this.$store.dispatch("report/updateTemplate", {
          reportId: this.reportId,
          templateId: this.customFile.id,
          submitInfo,
        })
        .then((result) => {
          this.$parent.close();
          snackbar.success(this, { message: "テンプレートを更新しました。"});
        })
        .catch((result) => {
          snackbar.error(this, { message: `テンプレートの更新に失敗しましたしました。${result}`});
        });
      });
    },
  },
  filters: {
    inValid(value) {
      if (!value || value === "undefined" ) {
        return "-";
      }
      return value;
    },
    short(value) {
      return value.slice(0, 8);
    },
    cutpath(value) {
      if (!value) {
        return;
      }
      const splittedVal = value.split("/");
      return splittedVal[splittedVal.length - 1];
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  justify-content: flex-end;
}
.main {
  display: flex;
  flex-direction: column;
  text-align: center;
  
  @media screen and (min-width:1024px) {
    min-width: 680px;
  }
}
</style>

<style>
.modal-update-template .dropdown-content {
  position: fixed;
}
</style>